import React from "react";
import {
    Card, CardBody, CardGroup
} from 'reactstrap';
import ReactDataGrid from "react-data-grid";
import IconAirlineSeat from 'react-icons/lib/md/airline-seat-recline-normal';
import IconFlight from 'react-icons/lib/md/flight-takeoff';
import IconMdDate from 'react-icons/lib/md/date-range';
//Icons
//  import { Table, Th, Thead, Tr, Td} from 'reactable';
import update from 'immutability-helper';
import {appHelpers} from "../../_helpers";
import {connect} from "react-redux";
import {appConstants} from "../../_constants";
import {apiActions} from "../../_actions/api.actions";
import {commonService} from "../../_services";
const { Editors } = require('react-data-grid-addons');
const { DropDownEditor } = Editors;
const currencyOfSale = ['USD', 'NGN'];

class IataValidationPageRecords extends React.Component {
    constructor(props, context) {
        super(props, context);
        const { isInitiator } = this.props;
        this._columns = [
            {
                key: 'TicketNumber',
                name: 'Ticket No.',
                editable: false,
                resizable: true,
                locked: true,
                sortable: true,
            },
            {
                key: 'PassengerType',
                name: 'PAX Type',
                editable: false,
                resizable: true,
                sortable: true
            },
            {
                key: 'Location1',
                name: '1',
                editable: isInitiator,
                resizable: true,
                sortable: true,
            },
            {
                key: 'Location2',
                name: '2',
                editable: isInitiator,
                resizable: true,
                sortable: true,
            },
            {
                key: 'Location3',
                name: '3',
                editable: isInitiator,
                resizable: true,
                sortable: true,
            },
            {
                key: 'Location4',
                name: '4',
                editable: isInitiator,
                resizable: true,
                sortable: true,
            },
            {
                key: 'Location5',
                name: '5',
                editable: isInitiator,
                resizable: true,
                sortable: true,
            },
            {
                key: 'Location6',
                name: '6',
                editable: isInitiator,
                resizable: true,
                sortable: true,
            },
            {
                key: 'FareType',
                name: 'Fare Type',
                editable: isInitiator,
                resizable: true,
                sortable: true,
            },
            {
                key: 'CurrencyOfSale',
                name: 'Currency',
                editor: (isInitiator) ? <DropDownEditor options={currencyOfSale}/> : null,
                editable: isInitiator,
                resizable: true,
                sortable: true,
                events: {
                }
            },
            {
                key: 'FareUSD',
                name: 'Fare ($)',
                editable: isInitiator,
                sortable: true,
            },
            {
                key: 'FareNGN',
                name: 'Fare (N)',
                editable: isInitiator,
                resizable: true,
                sortable: true,
            },
            {
                key: 'SalesLevyUSD',
                name: 'Sales Levy ($)',
                editable: isInitiator,
                resizable: true,
                sortable: true,
            },
            {
                key: 'SalesLevyNGN',
                name: 'Sales Levy (N)',
                editable: isInitiator,
                resizable: true,
                sortable: true,
            },
            {
                key: 'FreeTicket',
                name: 'Free Ticket',
                editable: isInitiator,
                resizable: true,
                sortable: true,
            },
            {
                key: 'Flag',
                name: 'Flag',
                editable: isInitiator,
                resizable: true,
                sortable: true,
            },
        ];

        this.state = {
            originalRows: [],
            rows: [],
        };
    }

    componentDidMount() {
        let {validationRecords} = this.props;
        this.setState({rows: [...validationRecords], originalRows: validationRecords})
    }

    rowGetter = (i) => {
        return this.state.rows[i];
    };

    handleGridRowsUpdated = ({ fromRow, toRow, updated }) => {
        let rows = this.state.rows.slice();
        for (let i = fromRow; i <= toRow; i++) {
            let rowToUpdate = rows[i];
            let updatedRow = update(rowToUpdate, {$merge: updated});
            this.saveValidationRecord(rowToUpdate, updatedRow, i);
            rows[i] = updatedRow;
        }
        this.setState({ rows });
    };
    handleGridSort = (sortColumn, sortDirection) => {
        const comparer = (a, b) => {
            if (sortDirection === 'ASC') {
                return (a[sortColumn] > b[sortColumn]) ? 1 : -1;
            } else if (sortDirection === 'DESC') {
                return (a[sortColumn] < b[sortColumn]) ? 1 : -1;
            }
        };

        const rows = sortDirection === 'NONE' ? this.state.originalRows.slice(0) : this.state.rows.sort(comparer);

        this.setState({ rows });
    };

    saveValidationRecord = (rowToUpdate, updatedRow, index) => {
        let  { dispatch, UserId, IataValidationId} = this.props;
        dispatch(apiActions.startRequest());

        let params = {
            IataValidationId,
            UserId,
            Entries: [updatedRow]
        };

        commonService.updateIATAValidationDetail(params)
            .then((res) => {
                if (res.status === appConstants.SUCCESS_RESPONSE) {
                    // let updatedRow = update(rowToUpdate, {$merge: updated});
                    let rows_ = [...this.state.rows];
                      rows_[index] = updatedRow;
                    this.setState({rows: rows_});
                    // this.setState({ validatingStatus });
                    this.props.notifyCallBack('Changes saved successfully', appConstants.NOTIFY_SUCCESS);
                    dispatch(apiActions.endRequest());
                }
                else if (res.status === appConstants.ERROR_RESPONSE) {
                    let rows_ = [...this.state.rows];
                    rows_[index] = rowToUpdate;
                    this.setState({rows: rows_});
                    this.props.notifyCallBack(res.response, appConstants.NOTIFY_ERROR);
                    dispatch(apiActions.endRequest());
                }
            });
    };

    render() {
        let { TotalPassengers, FlightNumber, FlightDate } = this.props;
        return (
            <div>
                <CardGroup className="sales-card mb-4">
                    <Card style={{'flex': '1.5 0 0'}}>
                        <CardBody  className="justify-content-between fit">
                            <h6 className="text-uppercase title font-weight-bold small">Flight Date</h6>
                            <h4 className="font-weight-normal mb-0">
                                <IconMdDate size="30" color="#b71c1c"/>&nbsp;{appHelpers.formatDateSpecific(FlightDate)}
                            </h4>
                        </CardBody>
                    </Card>
                    <Card>
                        <CardBody className={'fit'}>
                            <h6 className="text-uppercase title font-weight-bold small">Total Passengers</h6>
                            <h4 className="font-weight-normal mb-0"><IconAirlineSeat size="30" color="#0a3150"/>{appHelpers.numberWithCommasOnly(TotalPassengers)}</h4>
                        </CardBody>
                    </Card>
                    <Card style={{'flex': '1.5 0 0'}}>
                        <CardBody className={'fit'}>
                            <h6 className="text-uppercase title font-weight-bold small">Flight Number</h6>
                            <h4 className="font-weight-normal mb-0"><IconFlight size="30" color="#00897b"/>
                                &nbsp;{FlightNumber}
                            </h4>
                        </CardBody>
                    </Card>
                </CardGroup>
                {
                    (this.state.rows.length !== 0) &&
                    <ReactDataGrid
                        onGridSort={this.handleGridSort}
                        enableCellSelect={true}
                        columns={this._columns}
                        rowGetter={this.rowGetter}
                        rowsCount={this.state.rows.length}
                        minHeight={500}
                        onScrolll={this.onScroll}
                        onGridRowsUpdated={this.handleGridRowsUpdated}
                    />
                }
            </div>

        )
    }
}

function mapStateToProps(state, ownProps) {
    const { saveValidationCallback, validationRecords } = ownProps;
    const { requesting, pageRequesting } = state.api;
    const { modal, alert } = state;
    return {
        saveValidationCallback,
        validationRecords,
        requesting,
        pageRequesting,
        modal,
        alert,
    };
}
export default connect(mapStateToProps)(IataValidationPageRecords);



// WEBPACK FOOTER //
// ./src/views/iataValidation/iata-validation-page-records.js